/** Unsplash photo ids that 404 — rewrite so saved starter URLs still paint. */
const REPLACEMENTS: Record<string, string> = {
  'photo-1583241800698-9c4e6f5e8c1e': 'photo-1522335789203-aabd1fc54bc9',
  'photo-1620916566667-871e4d4e7e0e': 'photo-1571781926291-c477ebfd024b',
  'photo-1608248544102-2c8f2d8f7e0c': 'photo-1560066984-138dadb4c035',
  'photo-1620916568372-3027758c4688': 'photo-1570172619644-dfd03ed5d881',
  'photo-1570194065650-d99fb4b38b17': 'photo-1612817288484-6f916006741a',
  'photo-1595425970375-3c85fd915711': 'photo-1541643600914-78b084683601',
  'photo-1514362545857-3bc16c4c7d0b': 'photo-1551538827-9c037cb4f32a',
  'photo-1534438327276-8c4f6c73d4d5': 'photo-1571019614242-c5c5dee9f50b',
  'photo-1517649763962-0c623066027e': 'photo-1517836357463-d25dfeac3438',
  'photo-1468614005791-2981d5b2857b': 'photo-1552664730-d307ca884978',
  'photo-1513519245088-0e12902e35ca': 'photo-1610701596007-11502861dcfa',
}

export function repairUnsplashUrl(url: string): string {
  if (!url.includes('images.unsplash.com/photo-')) return url
  for (const dead of Object.keys(REPLACEMENTS)) {
    if (url.includes(dead)) return url.replace(dead, REPLACEMENTS[dead]!)
  }
  return url
}
